import { A_ComponentMeta } from "@adaas/a-concept";



export class AreDirectiveMeta extends A_ComponentMeta {

    priority: number = 0

}